import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQS } from "@/lib/data";

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="section-faq"
      className="py-14 sm:py-20 bg-gradient-to-b from-transparent to-slate-100/60 dark:to-white/[0.02]"
    >
      <div className="max-w-4xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="text-center">
          <span className="text-[11px] uppercase tracking-[0.24em] text-[#2563EB] dark:text-[#06B6D4] font-semibold">
            Frequently asked
          </span>
          <h2 className="font-display mt-4 text-4xl sm:text-5xl tracking-tighter font-semibold text-[#0F172A] dark:text-white text-balance">
            Questions, answered.
          </h2>
        </div>

        <Accordion
          type="single"
          collapsible
          className="mt-14 rounded-3xl border border-slate-200/80 dark:border-white/10 bg-white dark:bg-white/[0.03] hairline overflow-hidden"
        >
          {FAQS.map((f, i) => (
            <AccordionItem
              key={f.q}
              value={`faq-${i}`}
              data-testid={`faq-item-${i}`}
              className="border-b border-slate-200/70 dark:border-white/10 last:border-b-0 px-6 sm:px-8"
            >
              <AccordionTrigger className="py-6 text-left font-display text-base sm:text-lg font-medium tracking-tight text-[#0F172A] dark:text-white hover:no-underline">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[15px] leading-relaxed text-slate-600 dark:text-slate-300 pb-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
